// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3bShT","colCheckbox":"styles_colCheckbox__Ay0h-"};